import { supabase } from "../supabaseClient";
import axios from "axios";

export const getAllSalesManagers = async () => {
  try {
    // ✅ Step 1: get roleId
    const { data: roleData } = await supabase
      .from("Roles")
      .select("roleId")
      .eq("title", "Sales Manager")
      .eq("level", 4)
      .single();

    const roleId = roleData?.roleId;

    // ✅ Step 2: fetch users + leads + person details
    const { data, error } = await supabase
      .from("Users")
      .select(
        `
        userId,
        name,
        email,
        isActive,
        roleId,
        IsContactGroupCreated,
        IsTeleAccountCreated,
        

        Leads!Leads_userId_fkey (
          leadId,
          personId,

          Person!Leads_personId_fkey (
            name,
            email,
            contactNumber
          )
        )
      `,
      )
      .eq("roleId", roleId);

    console.log("🔥 RAW DATA:", data);

    if (error) return { success: false, error };

    // ✅ Step 3: format correctly
    const formatted = data.map((u) => {
      const leads = u.Leads || [];

      return {
        userId: u.userId,
        name: u.name,
        email: u.email,
        isActive: u.isActive,
        isTeleAccountCreated: u.IsTeleAccountCreated || false,
        isContactGroupCreated: u.IsContactGroupCreated || false,

        // ✅ FIXED COUNT
        leadsCount: leads.length,

        // ✅ Lead details
        leads: leads.map((l) => ({
          leadId: l.leadId,
          name: l.Person?.name || "-",
          email: l.Person?.email || "-",
          contact: l.Person?.contactNumber || "-",
        })),
      };
    });

    console.log("✅ FINAL DATA:", formatted);

    return { success: true, data: formatted };
  } catch (err) {
    console.error("❌ ERROR:", err);
    return { success: false, error: err };
  }
};

// CP Sourcing team members for the SmartFlo provisioning tab. Same shape as
// getAllSalesManagers rows but keyed off Users.isCpSourcingUser (no role lookup,
// no leads) plus how many approved CPs are assigned to them directly.
export const getAllCpSourcingUsers = async () => {
  try {
    const { data, error } = await supabase
      .from("Users")
      .select(
        `userId, name, email, isActive, IsTeleAccountCreated, IsContactGroupCreated, teleUserId, contactGroupId,
         CP!CP_cpSourceId_fkey ( cpId, approvalStatus )`
      )
      .eq("isCpSourcingUser", true)
      // count only the CPs the module actually works with: approved + enabled
      .eq("CP.approvalStatus", "approved");
      //.not("CP.isDisabled", "is", true);

    if (error) return { success: false, error };

    const formatted = (data || []).map((u) => ({
      userId: u.userId,
      name: u.name,
      email: u.email,
      isActive: u.isActive,
      isTeleAccountCreated: u.IsTeleAccountCreated || false,
      isContactGroupCreated: u.IsContactGroupCreated || false,
      smartfloUserId: u.teleUserId || null,
      contactGroupId: u.contactGroupId || null,
      cpCount: Array.isArray(u.CP) ? u.CP.length : 0,
    }));
    return { success: true, data: formatted };
  } catch (err) {
    console.error("❌ ERROR:", err);
    return { success: false, error: err };
  }
};

export const getLeadsBySalesManager = async (salesManagerId) => {
  try {
    const { data, error } = await supabase
      .from("Leads")
      .select(
        `
        leadId,
        leadStatus,
        leadResponse,
        leadType,
        leadDisplayId,

        Person:Person!Leads_personId_fkey (
          name,
          email,
          contactNumber
        ),

        Inventory (
          unitNo,
          displayUnitType,
          projectId,

          Projects (
            projectName
          )
        )
      `,
      )
      .eq("userId", salesManagerId);

    console.log("🔥 FINAL LEADS DATA:", data);

    if (error) {
      console.error("❌ Supabase Error:", error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (err) {
    console.error("❌ Catch Error:", err);
    return { success: false, error: err };
  }
};

export const createSmartfloUser = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_PAYMENT_LINK_URL}api/smartflo/create-user`,
      payload,
    );

    console.log("🔥 RESPONSE:", res.data);

    return res.data;
  } catch (err) {
    console.error("❌ ERROR:", err);
    throw err;
  }
};

export const createGroupAndUpload = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_PAYMENT_LINK_URL}api/smartflo/create-group-and-upload`,
      payload
    );

    console.log("🔥 COMBINED RESPONSE:", res.data);

    return res.data;

  } catch (err) {
    console.error("❌ COMBINED ERROR:", err);
    throw err;
  }
};
export const getSmartfloNumbers = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_PAYMENT_LINK_URL}api/smartflo/my-numbers`
    );

    console.log("🔥 Numbers:", res.data);

    return res.data;

  } catch (err) {
    console.error("❌ Error fetching numbers:", err);
    throw err;
  }
};

export const makeCall = async (payload) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_PAYMENT_LINK_URL}api/smartflo/make-call`,
      payload
    );

    console.log("🔥 Click-to-Call Response:", res.data)
    return res.data;
  } catch (err) {
    console.error("❌ Click-to-Call Error:", err);
    throw err;
  };
}

export const importLeadsFromExcel = async ({ file, salesManagerId }) => {
  try {
    const fileBase64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result;

        if (!result || typeof result !== "string") {
          reject(new Error("Failed to read Excel file"));
          return;
        }

        const base64 = result.split(",")[1];

        if (!base64) {
          reject(new Error("Invalid Excel file format"));
          return;
        }

        resolve(base64);
      };

      reader.onerror = () => {
        reject(new Error("Failed to convert Excel file to base64"));
      };

      reader.readAsDataURL(file);
    });

    const response = await axios.post(
      `${process.env.REACT_APP_PAYMENT_LINK_URL}api/smartflo/import-leads-excel`,
      {
        salesManagerId,
        file: fileBase64,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Import leads from Excel failed:", error);
    throw error;
  }
};

// export const createContactGroup = async (payload) => {
//   try {
//     const res = await axios.post(
//       "http://localhost:8050/api/smartflo/create-contact-group",
//       payload,
//     );

//     console.log("🔥 GROUP RESPONSE:", res.data);

//     return res.data;
//   } catch (err) {
//     console.error("❌ GROUP ERROR:", err);
//     throw err;
//   }
// };

// export const uploadLeadsToGroup = async (groupId, salesManagerId) => {
//   try {
//     const res = await axios.post(
//       "http://localhost:8050/api/smartflo/upload-leads",
//       {
//         groupId,
//         salesManagerId, // 🔥 IMPORTANT
//       },
//     );

//     console.log("🔥 UPLOAD RESPONSE:", res.data);

//     return res.data;
//   } catch (err) {
//     console.error("❌ UPLOAD ERROR:", err);
//     throw err;
//   }
// };
